<h1 mat-dialog-title>
  {{ (isEdit ? service.cid + '.update' : service.cid + '.create') | translate }}
  <mat-icon style="float: left; cursor: pointer;" (click)="closeDialog()">close</mat-icon>
</h1>
<div mat-dialog-content>
  <div ngClass.gt-md="form-spacing lg" [ngClass]="{ headerSmallSize: headerSmallSize }">
    <div class="overlay-form" *ngIf="!loaded || isSubmitted">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <form fxFlex fxLayout="column" class="core-form-style" [formGroup]="form">
      <div fxFlex fxLayout class="page_heading" *ngIf="service.page_heading">
        <span class="title">
          <breadcrumb #parent [hidden]="!showBreadcrumb">
            <div class="breadcrumb" *ngFor="let route of parent.breadcrumbs; let last = last">
              <a mat-button *ngIf="!route.terminal" href="" [routerLink]="[route.url]">{{
                route.displayName | translate
              }}</a>
              <a mat-button *ngIf="route.terminal">{{ route.displayName | translate }}</a>
              <span class="icon" *ngIf="!last">
                <mat-icon>chevron_right</mat-icon>
              </span>
            </div>
          </breadcrumb>
        </span>
        <app-form-footer
          (submit)="formSubmission()"
          (saveAddNew)="formSubmission(true)"
          (cancel)="cancelFormSubmission()"
          [form]="form"
          [isSaveAddNew]="isSaveAddNew"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        ></app-form-footer>
      </div>

      <div fxFlex fxLayout>
        <mat-card fxFlex>
          <mat-card-content>
            <div fxFlex="" fxLayout="column" class="d-flex flex-items-center">
              <div fxFlex="" fxLayout="column" class="default-form">
                <div
                  *ngFor="let groups of service.formInputsCategorized | pairs; trackBy: trackByFn"
                  fxFlex
                  fxLayout="column"
                  class="flex-wrap-margin-fixer"
                  [ngStyle]="{ 'margin-right': '-' + gridGapSize }"
                >
                  <!-- default inputs Group start  aka (no tab group or tabs )-->
                  <ng-container *ngIf="groups['key'] === 'defaultGroup'">
                    <ng-container *ngFor="let tab of groups['value'] | pairs; trackBy: trackByFn">
                      <ng-container *ngFor="let section of tab['value'] | pairs; trackBy: trackByFn">
                        <div class="form-section defaultSection" fxFlex="" fxLayout="column">
                          <div class="form-section-title" *ngIf="section['key'] !== 'defaultSection'">
                            {{ section['key'] | translate }}
                          </div>
                          <div class="form-section-content flex-wrap" fxFlex="column wrap" [fxLayoutGap]="gridGapSize">
                            <ng-template
                              [ngTemplateOutlet]="formTemplateRef"
                              [ngTemplateOutletContext]="{ form: section['value'] }"
                            >
                            </ng-template>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <!-- default inputs Group start -->

                  <!-- Tabs Groups start -->
                  <!-- <pre>{{groups | json}}</pre> -->

                  <!-- Tabs Groups start<pre>{{groups[1]}}</pre> -->
                  <ng-container *ngIf="groups['key'] !== 'defaultGroup'">
                    <mat-horizontal-stepper
                      [linear]="true"
                      labelPosition="bottom"
                      [selectedIndex]="service.getActiveTab(groups['key'])"
                      [ngClass]="groups['key']"
                      #stepper
                    >
                      <ng-container *ngFor="let tab of groups['value'] | pairs; let i = index">
                        <mat-step [completed]="steperComplete ? i === 0 : false">
                          <ng-template matStepLabel>
                            <span [class.tab_error]="tabsErrors[i]">
                              <mat-icon svgIcon="error" *ngIf="tabsErrors[i]"></mat-icon>
                              {{ tab['key'] | translate }}
                            </span>
                          </ng-template>
                          <div class="pt-5" fxFlex="" fxLayout="column">
                            <ng-container *ngFor="let section of tab['value'] | pairs; trackBy: trackByFn">
                              <div class="form-section" fxFlex="" fxLayout="column">
                                <div class="form-section-title" *ngIf="section['key'] !== 'defaultSection'">
                                  {{ section['key'] | translate }}
                                </div>
                                <div class="form-section-content flex-wrap" fxFlex [fxLayoutGap]="gridGapSize">
                                  <ng-template
                                    [ngTemplateOutlet]="formTemplateRef"
                                    [ngTemplateOutletContext]="{ form: section['value'] }"
                                  >
                                  </ng-template>
                                  <!--                                  <ng-container *ngFor="let field of section[1]">-->
                                  <!--                                    <ng-container *ngIf="field?.form && fieldShowConditions(field)">-->

                                  <!--                                      <app-core-form-content-->
                                  <!--                                        [cid]="service.cid"-->
                                  <!--                                        [service]="service"-->
                                  <!--                                        [field]="field"-->
                                  <!--                                        [form]="form"-->
                                  <!--                                        (showHideChanges)="showHideChanges($event)"-->
                                  <!--                                        [isEdit]="isEdit"-->
                                  <!--                                        [isClone]="isClone"-->
                                  <!--                                        [isSubmitted]="isSubmitted"-->
                                  <!--                                        (UpdateFormFieldValueEmitter)="UpdateFormFieldValue($event)"-->
                                  <!--                                        [fxFlex.gt-lg]="getInputGridSize(field?.form?.grid?.gt_lg, gridGapSize)"-->
                                  <!--                                        [fxFlex.lt-xl]="getInputGridSize(field?.form?.grid?.lt_xl, gridGapSize)"-->
                                  <!--                                        [fxFlex.lt-lg]="getInputGridSize(field?.form?.grid?.lt_lg, gridGapSize)"-->
                                  <!--                                        [fxFlex.lt-md]="getInputGridSize(field?.form?.grid?.lt_md, gridGapSize)"-->
                                  <!--                                        [fxFlex.lt-sm]="getInputGridSize(field?.form?.grid?.lt_sm, gridGapSize)"-->
                                  <!--                                      >-->
                                  <!--                                      </app-core-form-content>-->
                                  <!--                                    </ng-container>-->
                                  <!--                                  </ng-container>-->
                                </div>
                              </div>
                              <div class="stepper-actions" fxFlex="" fxLayout="row">
                                <button mat-button (click)="stepBack()" [disabled]="i === 0">
                                  <mat-icon
                                    color="primary"
                                    class="mdi-icon w-h-auto ml-2"
                                    fontSet="mdi"
                                    fontIcon="mdi-chevron-right-circle"
                                    [attr.size]="'24px'"
                                  ></mat-icon>

                                  <span class="display-inline-block">{{ 'pagination.previous' | translate }}</span>
                                </button>
                                <button
                                  mat-button
                                  (click)="groupTabCurrErrorsByKey(groups['value'], tab.key)"
                                  [disabled]="getLengthOfObject(groups['value']) - 1 === i"
                                >
                                  <mat-icon
                                    color="primary"
                                    class="mdi-icon w-h-auto mr-2"
                                    fontSet="mdi"
                                    fontIcon="mdi-chevron-left-circle"
                                    [attr.size]="'24px'"
                                  ></mat-icon>
                                  <span class="display-inline-block">{{ 'pagination.next' | translate }}</span>
                                </button>
                              </div>
                            </ng-container>
                          </div>
                        </mat-step>
                      </ng-container>
                    </mat-horizontal-stepper>
                  </ng-container>
                  <!-- Tabs Groups end -->
                </div>
              </div>
            </div>
          </mat-card-content>
          <mat-card-footer></mat-card-footer>
        </mat-card>
      </div>
      <div fxFlex *ngIf="page_heading" fxLayout class="page_footer">
        <span></span>
        <app-custom-form-footer
          (submit)="formSubmission()"
          (saveAddNew)="formSubmission(true)"
          (cancel)="cancelFormSubmission()"
          [form]="form"
          [isSaveAddNew]="isSaveAddNew"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        ></app-custom-form-footer>
      </div>
    </form>
  </div>

  <div class="dummyDataLoader" id="dummyDataLoader" *ngIf="service.dummyDataLoader">
    <button mat-icon-button (click)="loadDummyData()">
      <mat-icon color="warn">battery_unknown</mat-icon>
    </button>
  </div>
</div>

<div mat-dialog-content class="mat-dialog-actions">
  <app-custom-form-footer
    (submit)="formSubmission()"
    (saveAddNew)="formSubmission(true)"
    (cancel)="cancelFormSubmission()"
    [form]="form"
    [isSaveAddNew]="isSaveAddNew"
    [isEdit]="isEdit"
    [isClone]="isClone"
    [isSubmitted]="isSubmitted"
    [formValid]="arrayValid"
  >
  </app-custom-form-footer>
  <!--  <button mat-stroked-button color="warn" (click)="closeDialog()">خروج</button>-->
  <!--  <button mat-flat-button color="primary" (click)="formSubmission()" cdkFocusInitial>اعمل اللى انتا عاوزه</button>-->
</div>

<!-- Start Main Form Template -->

<!-- Define the recursive template. -->
<ng-template #formTemplateRef let-form="form" let-formGroup="formGroup" let-formArrayWrap="formArrayWrap">
  <ng-container *ngFor="let field of form; trackBy: trackByFn">
    <!-- Start not array -->
    <ng-container *ngIf="field?.form && field?.form?.formFieldType != 'formArray' && fieldShowConditions(field)">
      <!-- Initiate the recursive template rendering. -->
      <ng-container *ngIf="formGroup">
        <ng-template
          [ngTemplateOutlet]="fieldTemplateRef"
          [ngTemplateOutletContext]="{ field: field, formGroup: formGroup, formArrayWrap: formArrayWrap }"
        >
        </ng-template>
      </ng-container>
      <ng-container *ngIf="!formGroup">
        <ng-template [ngTemplateOutlet]="fieldTemplateRef" [ngTemplateOutletContext]="{ field: field }"> </ng-template>
      </ng-container>
    </ng-container>
    <!-- End not array -->
    <!-- Start Array -->
    <ng-container *ngIf="field?.form?.formFieldType == 'formArray'">
      <div [formGroup]="Form">
        <!-- // Initiate the recursive template rendering.  -->
        <div
          class="potato"
          [formArrayName]="field.form.name"
          *ngFor="let item of getArrayFormControls(field.form.name); let i = index"
        >
          <div
            fxFlex
            fxLayout="column"
            [formGroupName]="i"
            [hidden]="editId || editId === 0 ? i !== editId : i < getArrayFormControls(field?.form?.name).length - 1"
          >
            <ng-template
              [ngTemplateOutlet]="formTemplateRef"
              [ngTemplateOutletContext]="{
                form: field['form']['arrayForm'],
                formGroup: { id: i },
                formArrayWrap: field['form']['name']
              }"
            >
            </ng-template>
            <!--            <button-->
            <!--              mat-flat-button-->
            <!--              color="primary"-->
            <!--              class="btn-danger"-->
            <!--              (click)="removeArrayItem(field['form']['name'], i)"-->
            <!--              [disabled]=""-->
            <!--            >-->
            <!--              &lt;!&ndash; <mat-icon class="mat-18">save</mat-icon> &ndash;&gt;-->
            <!--              {{ 'common.remove' | translate }}-->
            <!--            </button>-->
          </div>
        </div>
      </div>
      <div>
        <button
          mat-flat-button
          color="primary"
          class="btn-primary"
          (click)="addArrayItem(field['form']['arrayForm'], field['form']['name'])"
          [disabled]=""
        >
          <!-- <mat-icon class="mat-18">save</mat-icon> -->
          {{ 'common.add' | translate }}
        </button>
      </div>
      <ng-template
        [ngTemplateOutlet]="tableTemplateRef"
        [ngTemplateOutletContext]="{
          array: getArrayFormControls(field.form.name),
          arrayForm: field['form']['arrayForm'],
          formName: field.form.name
        }"
      >
      </ng-template>
    </ng-container>
    <!-- End Array -->
  </ng-container>
</ng-template>
<!-- End Main Form Template -->

<ng-template #tableTemplateRef let-array="array" let-arrayForm="arrayForm" let-formName="formName">
  <!--  {{ array.value | json}}-->
  <section class="mdl-grid d-block  full-width" id="my-table">
    <div class="">
      <table class="mdl-data-table mdl-js-data-table mdl-data-table--selectable full-width" *ngIf="array.length > 1">
        <thead>
          <tr>
            <th></th>
            <th class="mdl-data-table__cell--non-numeric" *ngFor="let item of getDisplayedColumns(arrayForm)">
              {{ (item.list.hidden ? service.cid + '.' + item.name : '') | translate }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of array; let i = index" [hidden]="i === array.length - 1 || i === editId">
            <td>
              <mat-icon
                [popper]="popper1Content"
                [popperTrigger]="'hover'"
                [popperPlacement]="'bottom-end'"
                svgIcon="error"
                *ngIf="checkRowError(i)"
              ></mat-icon>

              <popper-content #popper1Content>
                <div *ngFor="let error of errorsMsgs[i]">
                  <p class="popper-msg">{{ error }}</p>
                </div>
              </popper-content>
            </td>
            <td class="mdl-data-table__cell--non-numeric" *ngFor="let keys of getDisplayedColumns(arrayForm)">
              <ng-container *ngIf="keys?.groupFields">
                <ng-container *ngFor="let group of keys?.groupFields">
                  <ng-container *ngIf="group.type === 'array'">
                    <span class="gray-tag">{{ item.value[group.prop] }}</span>
                  </ng-container>
                  <ng-container *ngIf="group.type === 'input_array'">
                    <span class="gray-tag" *ngFor="let value of item.value[group.prop]">{{
                      getSelectedItem(keys.form.listPrefix, value, array.length)
                    }}</span>
                  </ng-container>
                  <ng-container *ngIf="group.type === 'boolean'">
                    <!-- <span class="gray-tag" *ngFor="let key of keys?.groupFields">{{ item.value[key.prop] }}</span> -->

                    <div class="field-container">
                      <mat-slide-toggle color="primary" [checked]="item.value[keys?.name]" [disabled]="true">
                      </mat-slide-toggle>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!keys?.groupFields">
                <span class="text-primary">{{ getSelectedItem(keys.form.listPrefix, item.value[keys?.name], i) }}</span>
              </ng-container>
            </td>
            <td class="text-left">
              <mat-icon class="mr-4 cursor-pointer icon-md main-color" (click)="stepperRowAction('edit', formName, i)">
                edit</mat-icon
              >
              <mat-icon
                class="cursor-pointer icon-md warn"
                color="warn"
                (click)="stepperRowAction('delete', formName, i)"
                >close</mat-icon
              >
            </td>
          </tr>
        </tbody>
      </table>

      <!-- <table mat-table [dataSource]="array.value" class="mat-elevation-z8"> -->
      <!-- Name Column -->
      <!-- <ng-container *ngFor="let item of getDisplayedColumns(array.value)" [matColumnDef]="item">
      {{ cid.item | translate }}
      <th mat-header-cell *matHeaderCellDef>{{ service.cid + '.' + item | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element[item] }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(array.value)"></tr>
    <tr mat-row *matRowDef="let row; columns: getDisplayedColumns(array.value)"></tr> -->
      <!-- </table> -->
    </div>
  </section>
</ng-template>
<!-- Start Single Field Template -->
<ng-template #fieldTemplateRef let-field="field" let-formGroup="formGroup" let-formArrayWrap="formArrayWrap">
  <ng-container *ngIf="field?.form && fieldShowConditions(field)">
    <ng-container *ngIf="formGroup && formArrayWrap">
      <app-core-form-content
        [cid]="service.cid"
        [service]="service"
        [field]="field"
        [form]="getArrayFormControls(formArrayWrap)[formGroup.id]"
        (showHideChanges)="showHideChanges($event)"
        [isEdit]="isEdit"
        [isClone]="isClone"
        [isSubmitted]="isSubmitted"
        (UpdateFormFieldValueEmitter)="UpdateFormFieldValue($event)"
        [fxFlex.gt-lg]="getInputGridSize(field?.form?.grid?.gt_lg, gridGapSize)"
        [fxFlex.lt-xl]="getInputGridSize(field?.form?.grid?.lt_xl, gridGapSize)"
        [fxFlex.lt-lg]="getInputGridSize(field?.form?.grid?.lt_lg, gridGapSize)"
        [fxFlex.lt-md]="getInputGridSize(field?.form?.grid?.lt_md, gridGapSize)"
        [fxFlex.lt-sm]="getInputGridSize(field?.form?.grid?.lt_sm, gridGapSize)"
      >
      </app-core-form-content>
    </ng-container>
    <ng-container *ngIf="!formArrayWrap">
      <app-core-form-content
        [cid]="service.cid"
        [service]="service"
        [field]="field"
        [form]="form"
        (showHideChanges)="showHideChanges($event)"
        [isEdit]="isEdit"
        [isClone]="isClone"
        [isSubmitted]="isSubmitted"
        (UpdateFormFieldValueEmitter)="UpdateFormFieldValue($event)"
        [fxFlex.gt-lg]="getInputGridSize(field?.form?.grid?.gt_lg, gridGapSize)"
        [fxFlex.lt-xl]="getInputGridSize(field?.form?.grid?.lt_xl, gridGapSize)"
        [fxFlex.lt-lg]="getInputGridSize(field?.form?.grid?.lt_lg, gridGapSize)"
        [fxFlex.lt-md]="getInputGridSize(field?.form?.grid?.lt_md, gridGapSize)"
        [fxFlex.lt-sm]="getInputGridSize(field?.form?.grid?.lt_sm, gridGapSize)"
      >
      </app-core-form-content>
    </ng-container>
  </ng-container>
</ng-template>
<!-- End Single Field Template -->
